// Dependency-free so eager callers (lib/api/auth) don't pull react-international-phone
// into the main bundle via phoneLocale's module-level country tables.

/**
 * E.164-style value for SMS APIs: leading + and digits only (e.g. +201115262943).
 */
export function toE164Phone(phone: string): string {
  const digits = phone.replace(/\D/g, "");
  if (!digits) return "";
  return `+${digits}`;
}
